import ReporteBase from "./ReportePage.js";

const ReporteNoConfirmados = () => {
    return (
        <ReporteBase
            titulo="Detalles No Confirmados"
            variant="NOCONFIRMADOS"
        />
    );
};

export default ReporteNoConfirmados;
